import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "external", "hideExternalLinkIcon", "href", "minInlineSize", "onClick", "target", "truncate", "typography", "use"];
import * as stylex from '@stylexjs/stylex';
import { Link } from 'foundations-components/transitional/components/Link';
import { LinkRoot } from 'trellis-components/components/Link/primitives';
import { unsafeReactNode } from 'trellis-components/utils/unsafeReactNode';
import { unsafeXStyle } from 'trellis-components/utils/unsafeXStyle';
import { Text } from 'trellis-components/components/Text';
import { useUiVariant } from './UiVariantProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const _temp = {
  minWidth: "x1d6dtaj",
  "$$css": true
};
// TODO: Replace the LinkRoot path with a Trellis-provided way to truncate a
// link label next to its end icon once the config Link supports it. Today the
// documented `<Text truncated>` child pushes the external icon onto a second
// line, so truncated links render LinkRoot as an inline-flex row instead.
// https://hubspot.slack.com/archives/C1WG3L3J6/p1791985885291499
const truncateStyles = {
  row: {
    alignItems: "x1pha0wt",
    display: "x3nfvp2",
    maxWidth: "x193iq5w",
    $$css: true
  },
  minInlineSize: minInlineSize => [_temp, {
    "--x-minInlineSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(minInlineSize)
  }],
  inheritFont: {
    fontSize: "x1qlqyl8",
    lineHeight: "x15bjb6t",
    $$css: true
  }
};
const syncBlankTarget = (isIconHidden, target) => element => {
  if (isIconHidden) {
    element === null || element === void 0 || element.setAttribute('target', '_blank');
  } else if (target === undefined) {
    element === null || element === void 0 || element.removeAttribute('target');
  }
};
const TrellisCdpLink = _ref => {
  let {
      children,
      external = false,
      hideExternalLinkIcon = false,
      href,
      minInlineSize,
      onClick,
      target,
      truncate = false,
      typography
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const resolvedTarget = target !== null && target !== void 0 ? target : external ? '_blank' : undefined;
  const isIconHidden = hideExternalLinkIcon && resolvedTarget === '_blank';
  return /*#__PURE__*/_jsx(LinkRoot, Object.assign({}, rest, {
    ref: syncBlankTarget(isIconHidden, resolvedTarget),
    href: href,
    onClick: href ? onClick : undefined,
    onPress: !href && onClick ? evt => onClick(evt) : undefined,
    target: isIconHidden ? undefined : resolvedTarget,
    rel: isIconHidden ? 'noopener noreferrer' : undefined,
    size: typography === 'link-25' ? 'sm' : undefined,
    xstyle: unsafeXStyle([typography !== 'link-25' && truncateStyles.inheritFont, truncate && truncateStyles.row, minInlineSize != null && truncateStyles.minInlineSize(String(minInlineSize))]),
    children: truncate ? /*#__PURE__*/_jsx(Text, {
      truncated: true,
      children: children
    }) : unsafeReactNode(children)
  }));
};
const FoundationsCdpLink = props => {
  const {
    disabled,
    href,
    onClick
  } = props;
  const handleKeyDown = href || disabled || !onClick ? undefined : evt => {
    if (evt.key === 'Enter' && evt.target === evt.currentTarget) {
      onClick(evt);
    }
  };
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    onKeyDown: handleKeyDown
  }));
};
export const CdpLink = props => {
  const variant = useUiVariant();
  return variant === 'trellis' ? /*#__PURE__*/_jsx(TrellisCdpLink, Object.assign({}, props)) : /*#__PURE__*/_jsx(FoundationsCdpLink, Object.assign({}, props));
};